import { Link, useNavigate } from "react-router-dom";
import { projectsData } from "../data/projectsData";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function PortfolioPage() {

  const navigate = useNavigate();

  return (
    <section className="py-24 md:py-32 bg-[#FDFBF7]">

      <div className="max-w-7xl mx-auto px-6 md:px-16">

        {/* Top Bar */}

        <div className="flex items-center justify-between mb-10">

          {/* Back Button */}

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-[#2C2C2C]/70 hover:text-[#C9A962] transition"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>


          {/* Title */}

          <h1 className="text-4xl md:text-5xl font-serif text-[#2C2C2C]">
            Our Projects
          </h1>

          <div></div>

        </div>


        {/* Projects Grid */}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          {projectsData.map((project, index) => (

            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.08 }}
            >

              <Link
                to={`/project/${project.id}`}
                className="group block relative overflow-hidden"
              >

                {/* Image */}

                <img
                  src={project.images[0]}
                  alt={project.title}
                  className="w-full h-72 object-cover group-hover:scale-110 transition duration-700"
                />


                {/* Overlay */}

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-70 group-hover:opacity-90 transition"></div>


                {/* Content */}

                <div className="absolute bottom-0 left-0 p-6">

                  <p className="text-[#C9A962] text-xs tracking-widest uppercase mb-1">
                    {project.category}
                  </p>

                  <h3 className="text-white text-xl font-serif">
                    {project.title}
                  </h3>

                  <p className="text-white/70 text-sm mb-2">
                    {project.location}
                  </p>

                  <div className="flex items-center text-white opacity-0 group-hover:opacity-100 transition">
                    View Project
                    <ArrowUpRight className="ml-2 w-4 h-4" />
                  </div>

                </div>

              </Link>

            </motion.div>

          ))}

        </div>

      </div>

    </section>
  );
}